export default __webpack_public_path__ + "static/media/premium-clock-icon-luxe.3a465c21d7de10cb6bfc7ec6cea0133e.svg";